import { render } from "./TextTip.vue?vue&type=template&id=74925ff7&scoped=true&ts=true"
import script from "./TextTip.vue?vue&type=script&lang=ts"
export * from "./TextTip.vue?vue&type=script&lang=ts"

import "./TextTip.vue?vue&type=style&index=0&id=74925ff7&scoped=true&lang=scss"
import "./TextTip.vue?vue&type=style&index=1&id=74925ff7&lang=scss"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74925ff7"]])

export default __exports__